import { useTheme } from '@material-ui/core';
import { COLORS } from 'shared/constants/COLORS';
import { NoteCont, Wrapper, Label, ButtonCont } from '../RoleItem.styles';
import { RoleDetailsCont, MediaCont, DetailsCont, RoleButton } from './RoleDetails.styles';
import { Skeleton } from '@material-ui/lab';

const RoleContentLoader = () => {
  const isDark = useTheme().palette.type === 'dark';
  const threeSkeletonText = () =>
    Array.from({ length: 3 }).map((_, i) => <Skeleton key={i} variant="text" width={'100%'} height={20} />);

  return (
    <RoleDetailsCont>
      <MediaCont>
        {Array.from({ length: 2 }).map((_, i) => (
          <Skeleton key={i} variant="rect" width={80} height={80} style={{ marginRight: 10 }} />
        ))}
      </MediaCont>
      <DetailsCont>
        <NoteCont>
          <Wrapper rolecontent={1}>
            <Label>Description: </Label>
            {threeSkeletonText()}
          </Wrapper>

          <Wrapper rolecontent={1}>
            <Label>Working Note:</Label>
            {threeSkeletonText()}
          </Wrapper>
        </NoteCont>
        <NoteCont
          style={{
            borderTop: `1px solid ${isDark ? COLORS.DARK_BORDER : COLORS.LIGHT_BORDER}`,
            paddingTop: 10,
          }}
        >
          <Wrapper rolecontent={1}>
            <Label>Audition Note: </Label>
            {threeSkeletonText()}
          </Wrapper>

          <Wrapper rolecontent={1}>
            <Label>Wardrobe Note:</Label>
            {threeSkeletonText()}
          </Wrapper>
        </NoteCont>
        {/* <ButtonCont>
          <RoleButton variant="outlined" color="primary">
            Edit Profile
          </RoleButton>
          <RoleButton variant="contained" color="primary">
            Submit
          </RoleButton>
        </ButtonCont> */}
      </DetailsCont>
    </RoleDetailsCont>
  );
};

export default RoleContentLoader;
